module.exports = __webpack_public_path__ + "static/media/wait.ae3241fc.mp3";